/**
 * 环境配置工具
 * 用于获取不同环境下的配置信息
 */

// 获取环境变量，提供默认值
export const getEnv = (key, defaultValue = '') => {
  return process.env[key] || defaultValue;
};

// 环境信息
export const ENV = {
  // 当前环境
  NODE_ENV: getEnv('NODE_ENV', 'development'),
  VUE_APP_ENV: getEnv('VUE_APP_ENV', 'development'),
  
  // API配置
  API_BASE_URL: getEnv('VUE_APP_API_BASE_URL', 'https://api.zlsx-cts.com'),
  API_PREFIX: getEnv('VUE_APP_API_PREFIX', '/api'),
  
  // 应用配置
  TITLE: getEnv('VUE_APP_TITLE', '供应链管理系统'),
  VERSION: getEnv('VUE_APP_VERSION', '0.1.0'),
  
  // 调试配置
  DEBUG: getEnv('VUE_APP_DEBUG', 'false') === 'true',
  LOG_LEVEL: getEnv('VUE_APP_LOG_LEVEL', 'info'),
  
  // 其他配置
  UPLOAD_URL: getEnv('VUE_APP_UPLOAD_URL', 'https://api.zlsx-cts.com/upload'),
  DOWNLOAD_URL: getEnv('VUE_APP_DOWNLOAD_URL', 'https://api.zlsx-cts.com/download'),
  
  // 性能配置
  ENABLE_ANALYTICS: getEnv('VUE_APP_ENABLE_ANALYTICS', 'false') === 'true',
  ENABLE_MONITORING: getEnv('VUE_APP_ENABLE_MONITORING', 'false') === 'true'
};

// 判断是否为开发环境
export const isDevelopment = () => {
  return ENV.NODE_ENV === 'development' || ENV.VUE_APP_ENV === 'development';
};

// 判断是否为生产环境
export const isProduction = () => {
  return ENV.NODE_ENV === 'production' || ENV.VUE_APP_ENV === 'production';
};

// 获取完整的API URL
export const getApiUrl = (endpoint = '') => {
  const baseUrl = ENV.API_BASE_URL;
  const prefix = ENV.API_PREFIX;
  const url = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${baseUrl}${prefix}${url}`;
};

// 日志工具
export const logger = {
  debug: (message, ...args) => {
    if (ENV.DEBUG && ENV.LOG_LEVEL === 'debug') {
      console.log(`[DEBUG] ${message}`, ...args);
    }
  },
  info: (message, ...args) => {
    if (['debug', 'info'].includes(ENV.LOG_LEVEL)) {
      console.log(`[INFO] ${message}`, ...args);
    }
  },
  warn: (message, ...args) => {
    if (['debug', 'info', 'warn'].includes(ENV.LOG_LEVEL)) {
      console.warn(`[WARN] ${message}`, ...args);
    }
  },
  error: (message, ...args) => {
    if (['debug', 'info', 'warn', 'error'].includes(ENV.LOG_LEVEL)) {
      console.error(`[ERROR] ${message}`, ...args);
    }
  }
};

// 导出默认配置
export default ENV;
